/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import {FormattedMessage} from 'react-intl'
import {HeaderUserCreds} from './HeaderUserCreds'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      {/* <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>
          <HeaderUserCreds />
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.firstName} {currentUser?.lastName}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.externalId}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div> */}
      <div className='menu-item px-5'>
        <Link to={'/dashboard'} className='menu-link px-5'>
          <FormattedMessage id='DASHBOARD.PAGE.PAGE_TITLE' />
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          <FormattedMessage id='SIDEBAR.PROFILE_TITLE' />
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to={'/receivers'} className='menu-link px-5'>
          <FormattedMessage id='RECEIVERS.PAGE.PAGE_TITLE' />
        </Link>
      </div>
      <div className='menu-item px-5'>
        <Link to={'/news'} className='menu-link px-5'>
          <FormattedMessage id='NEWS.PAGE.PAGE_TITLE' />
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to={'/warehouse'} className='menu-link px-5'>
          {' '}
          <span className='menu-text'>
            <FormattedMessage id='USA_WAREHOUSE.PAGE.PAGE_TITLE' />
          </span>
        </Link>

        {/* <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span> */}
      </div>

      {/* <div className='menu-item px-5'>
        <Link to='/tracks' className='menu-link px-5'>
          <span className='menu-title'>
            <FormattedMessage id='TRACKS.PAGE.PAGE_TITLE' />
          </span>
          <span className='menu-arrow'></span>
        </Link> */}

      {/* <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div> */}
      {/* </div> */}

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5 my-1'>
        <Link to='balance' className='menu-link px-5'>
          <span className='me-1'>
            <FormattedMessage id='HEADER_USER_MENU.BALANCE' />{' '}
          </span>
          (
          <span
            style={{color: currentUser?.balance && +currentUser.balance >= 0 ? 'green' : 'red'}}
          >
            {currentUser?.balance}
          </span>
          )
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to='/logout' className='menu-link px-5'>
          <FormattedMessage id='HEADER_USER_MENU.LOGOUT' />
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
